import ProductsView from "../../../../components/Products/ProductsView.vue";

export default { path: '/:slug(.*)', component: ProductsView };
